import { render } from "./VoucherCartItem.vue?vue&type=template&id=abbc0370&scoped=true"
import script from "./VoucherCartItem.vue?vue&type=script&lang=js"
export * from "./VoucherCartItem.vue?vue&type=script&lang=js"

import "./VoucherCartItem.vue?vue&type=style&index=0&id=abbc0370&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abbc0370"]])

export default __exports__